import { IPersonalAccountsItemDTO } from 'interfaces'

export const Location: TAnt.TableColumnRender<string, IPersonalAccountsItemDTO> = (
  _,
  { location: { cityName = '', code = '' } }
) => <>{cityName && code ? `${cityName}, ${code.toLocaleUpperCase()}` : 'N/A'}</>
